export default __webpack_public_path__ + "static/media/Stalker's Cord of Creeping Death.cb36fc37.jpg";